import { faBriefcase, faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../firebase.init';
import Loading from '../../Shared/Loading';




const AboutMe = () => {


    const [user, loading] = useAuthState(auth);
    const [aboutMe, setAboutMe] = useState([]);

    const email = user?.email;

    useEffect(() => {
        const url = `https://stark-wildwood-35883.herokuapp.com/aboutme`;
        fetch(url)
            .then(res => res.json())
            .then(data => setAboutMe(data))
    }, [email])

    const me = aboutMe?.find((e) => e?.email === 'coder@webdeveloper.com');

  

    if (loading) {
        return <Loading />
    }





    return (
        <div className='py-5 lg:pb-10' id='about'>
            <div className='mb-10'
                data-aos="fade-down"
            >
                <h3 className='text-center text-2xl uppercase font-semibold text-green-500'>Main Info</h3>
                <h3 className='text-center text-3xl uppercase font-semibold py-2'>About Me</h3>
            </div>
            <div className="hero " id='aboutme'>
                <div className="hero-content lg:flex-row md:flex-row flex-col    ">
                    <div className='lg:w-1/2  md:w-1/2  py-4 '
                        data-aos="fade-right"
                        data-aos-anchor="#example-anchor"
                        data-aos-offset="500"
                        data-aos-duration="1000"
                    >
                        {me?.img && <img src={me?.img} alt="Profile_Picture" className=' profile_Shadow rounded-full lg:w-9/12 w-80 md:w-10/12 mx-auto mb-5 ' />}
                    </div>
                    <div className='lg:w-1/2 md:text-left text-center md:w-1/2 '>
                        <p className='text-lg text-gray-500 mb-4 md:p-0 p-2'

                            data-aos="fade-right"
                            data-aos-anchor="#example-anchor"
                            data-aos-offset="500"
                            data-aos-duration="800"

                        > <span className='text-primary font-bold'>Hi ! I’m Md. Shakil Ahmed .</span> {me?.myself}</p>
                        {me?.myhobbies && <p className='text-lg text-gray-500 mb-4 md:p-0 p-2'
                            data-aos="fade-right"
                            data-aos-anchor="#example-anchor"
                            data-aos-offset="500"
                            data-aos-duration="1000"
                        >{me?.myhobbies}</p>}
                        <div className='flex md:justify-start justify-center'
                            data-aos="fade-up"
                            data-aos-anchor="#example-anchor"
                            data-aos-offset="500"
                            data-aos-duration="800"
                        >
                            <a href="https://drive.google.com/file/d/1xuwhHCxnt8kwe5GHlOsY0jalDTGyd1K3/view?usp=sharing" target="_blank" rel="noopener"> <button className='btn  btn-md btn-primary mr-3 text-sm border-0 text-white  ' >Download Resume <FontAwesomeIcon className='ml-2 ' icon={faCircleArrowRight} /></button></a>
                            <a className="btn btn-secondary text-white" href="https://www.linkedin.com/in/codermdshakil/" target="_blank" rel="noopener">Hire Me <FontAwesomeIcon className='ml-2' icon={faBriefcase} /> </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutMe;